type EcosystemItem = {
  index: string;
  name: string;
  tagline: string;
  href: string;
};

type FooterEcosystemProps = {
  items?: EcosystemItem[];
  eyebrow?: string;
  intro?: string;
};

/**
 * Wiersz firm ekosystemu w stopce - układ "manifest po lewej, indeks firm po prawej".
 * Firmy układają się obok siebie (3 kolumny na desktopie, 2 na tablecie, 1 na mobilnym),
 * każda jako karta z górnym hairline'em (spójnie z kartami advantage/careers),
 * strzałka wjeżdża na hover, nazwa rozświetla się do acid green.
 *
 * COPY z i18n (footer.ecosystem.*). Nazwy/hrefy przekazywane z PositiveRecruitment.
 */
const DEFAULT_ITEMS: EcosystemItem[] = [
  { index: "01", name: "MOCNE.AI", tagline: "Custom AI dla MŚP. Zero hype - inżynieria, która rusza metryki biznesowe.", href: "https://mocne.ai" },
  { index: "02", name: "P-REC", tagline: "NIS2 i cyberbezpieczeństwo. Wymogi regulacyjne zamienione w przewagę.", href: "https://p-rec.pl" },
];

export function FooterEcosystem({ items = DEFAULT_ITEMS, eyebrow, intro }: FooterEcosystemProps) {
  return (
    <div className="grid gap-x-8 gap-y-8 md:gap-y-10 md:grid-cols-12">
      {(eyebrow || intro) && (
        <div className="md:col-span-5 lg:col-span-4 border-t border-white/10 pt-4 md:pt-5">

          {eyebrow && (
            <span className="inline-flex items-center gap-2.5 font-mono text-[10px] uppercase tracking-[0.28em] text-white/50">
              <span aria-hidden className="inline-block h-1.5 w-1.5 bg-lime-300" />
              {eyebrow}
            </span>
          )}
          {intro && (
            <p className="mt-3 md:mt-4 max-w-xs text-[15px] md:text-lg font-medium leading-snug text-white/85">
              {intro}
            </p>
          )}
        </div>
      )}

      <div className="md:col-span-7 lg:col-span-8 grid gap-x-8 gap-y-6 md:gap-y-8 sm:grid-cols-2 lg:grid-cols-3">

        {items.map((item) => (
          <a
            key={item.index}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex h-full flex-col border-t border-white/10 pt-4 md:pt-5 transition-colors hover:border-lime-300/50"
          >
            <span className="mb-2 md:mb-3 block font-mono text-[10px] tracking-[0.12em] text-white/40">{item.index} /</span>
            <span className="mb-2 flex items-center gap-2 text-[15px] md:text-lg font-bold tracking-tight text-white/90 transition-colors group-hover:text-lime-300">
              {item.name}
              <span aria-hidden className="inline-block transition-transform group-hover:translate-x-1">→</span>
            </span>
            <span className="block text-[13px] md:text-sm leading-relaxed text-white/55">{item.tagline}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
